document.documentElement.classList.remove('no-js');
(()=>{
 const root=document.getElementById('cf-concepts');
 const header=root.querySelector('.cf-header-left');
 const toggle=header.querySelector('.cf-menu-toggle');
 const nav=header.querySelector('nav');
 const compact=window.matchMedia('(max-width:899px)');
 function close(returnFocus=false){
  header.removeAttribute('data-menu-open');
  toggle.setAttribute('aria-expanded','false');
  toggle.setAttribute('aria-label','Open navigation menu');
  if(returnFocus)toggle.focus();
 }
 toggle.addEventListener('click',()=>{
  const open=toggle.getAttribute('aria-expanded')!=='true';
  header.setAttribute('data-menu-open',String(open));
  toggle.setAttribute('aria-expanded',String(open));
  toggle.setAttribute('aria-label',open?'Close navigation menu':'Open navigation menu');
 });
 nav.addEventListener('click',event=>{if(event.target.closest('a'))close();});
 header.querySelector('.cf-home-link').addEventListener('click',()=>close());
 document.addEventListener('keydown',event=>{if(event.key==='Escape'&&toggle.getAttribute('aria-expanded')==='true')close(true);});
 document.addEventListener('click',event=>{if(!header.contains(event.target))close();});
 compact.addEventListener('change',()=>close());
})();

(function(){
 const root=document.getElementById('cf-concepts');
 if(!root)return;
 const header=root.querySelector('header');
 function measureHeader(){
  root.style.setProperty('--cf-header-height',(header ? header.getBoundingClientRect().height : 0)+'px');
 }
 measureHeader();
 if(header && typeof ResizeObserver==='function')new ResizeObserver(measureHeader).observe(header);
 else window.addEventListener('resize',measureHeader);

 root.querySelectorAll('a[href^="#"]').forEach(function(link){
  link.addEventListener('click',function(event){
   const id=link.getAttribute('href').slice(1);
   const target=document.getElementById(id);
   if(!target)return;
   event.preventDefault();
   const top=id==='cf-concepts';
   const height=header ? header.getBoundingClientRect().height : 0;
   const gap=['cf-about-left','cf-newsletter-left'].includes(id) ? 0 : 18;
   const y=top ? 0 : Math.max(0,window.scrollY+target.getBoundingClientRect().top-height-gap);
   const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   window.scrollTo({top:y,behavior:reduced?'instant':'smooth'});
   const focusTarget=top ? root.querySelector('.cf-home-link') : target;
   if(focusTarget){
    if(!focusTarget.matches('a,button,input,select,textarea'))focusTarget.setAttribute('tabindex','-1');
    focusTarget.focus({preventScroll:true});
   }
  });
 });
})();

const CF_NEWSLETTER_API = 'https://common-flavor-api.curly-dust-3326.workers.dev/api/newsletter-signup';

document.querySelectorAll('[data-cf-newsletter-form], [data-cf-contact-form]').forEach((form) => {
  const newsletter = form.hasAttribute('data-cf-newsletter-form');
  const pendingLabel = newsletter ? 'Signing up…' : 'Sending…';
  const failureMessage = newsletter ? 'We couldn’t complete your signup. Please try again.' : 'We couldn’t send your message. Please try again.';
  // Install before Shopify binds CAPTCHA: its wrapper captures this function,
  // obtains a valid token, then calls it instead of navigating via native submit.
  let sending = false;
  let captchaTimer;
  const button = form.querySelector('[data-cf-submit]');
  const status = form.querySelector('.cf-form-status');
  const label = button?.textContent;
  function finish() {
    clearTimeout(captchaTimer);
    sending = false;
    delete form.dataset.submitting;
    form.removeAttribute('aria-busy');
    if (button) { button.disabled = false; button.textContent = label; }
  }
  form.submit = async function submitInlineForm() {
    if (sending) return;
    sending = true;
    clearTimeout(captchaTimer);
    const firstName = form.querySelector('[data-cf-first-name]')?.value.trim() || '';
    const lastName = form.querySelector('[data-cf-last-name]')?.value.trim() || '';
    const email = form.querySelector('[data-cf-email]')?.value.trim() || '';
    const body = new URLSearchParams(new FormData(form));
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) { button.disabled = true; button.textContent = pendingLabel; }
    if (status) status.textContent = '';
    try {
      const response = await fetch(form.action, {
        method: 'POST', body, credentials: 'same-origin'
      });
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = page.querySelector('#' + form.id + ' .cf-form-status');
      const message = result?.textContent.trim() || '';
      if (!response.ok || !message.startsWith(newsletter ? 'Thanks for subscribing' : 'Thanks for reaching out')) {
        throw new Error(message || failureMessage);
      }
      if (newsletter) {
        // Keep Shopify's customer record and sync the marketing contact to Brevo.
        const marketing = await fetch(CF_NEWSLETTER_API, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ firstName, lastName, email })
        });
        if (!marketing.ok) {
          if (status) status.textContent = 'Your signup was saved, but the mailing-list sync could not finish. Please try again.';
        } else if (status) {
          status.textContent = message;
        }
      } else if (status) {
        status.textContent = message;
      }
    } catch (error) {
      if (status) status.textContent = error.message || failureMessage;
    } finally {
      finish();
    }
  };
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    // Shopify also has a submit-event handler. Call its protected submit wrapper
    // once ourselves, so neither it nor the document handler submits twice.
    event.stopImmediatePropagation();
    if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    if (button) { button.disabled = true; button.textContent = pendingLabel; }
    if (status) status.textContent = '';
    const protect = window.Shopify?.captcha?.protect;
    if (typeof protect !== 'function') {
      form.submit();
      return;
    }
    captchaTimer = setTimeout(() => {
      if (status) status.textContent = 'Verification did not finish. Please try again.';
      finish();
    }, 65000);
    if (form.dataset.hcaptchaBound || form.dataset.recaptchaBound) {
      form.submit();
    } else {
      protect(form, () => {
        if (form.dataset.submitting !== 'true') return;
        if (!form.dataset.hcaptchaBound && !form.dataset.recaptchaBound) {
          if (status) status.textContent = 'Verification could not load. Please try again.';
          finish();
          return;
        }
        form.submit();
      });
    }
  });
});

// Only offer the spotlight anchor when its product section is rendered.
(function () {
  function syncWeeklyLinks() {
    const available = Boolean(document.getElementById('cf-weekly-flavor'));
    document.querySelectorAll('[data-cf-weekly-link]').forEach((link) => {
      link.hidden = !available;
    });
  }
  syncWeeklyLinks();
  document.addEventListener('shopify:section:load', syncWeeklyLinks);
  document.addEventListener('shopify:section:unload', () => {
    requestAnimationFrame(syncWeeklyLinks);
  });
})();
